export default "__VITE_ASSET__Dxml3Ng5__"